import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getRequest } from '../../../../hooks/axiosClient';
import { setAllPins, setPinsByCategory } from '../../../../store/slices/projectItemSlice';
import { GetFloorData } from '../helpers/projectApi';

export const useLoadPins = (id) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadData = useCallback(async () => {
    if (!id) return;

    setLoading(true);
    setError(null);

    try {
      const pins = await fetchPinData(id, Object.keys(ENDPOINTS));
      dispatch(setAllPins(pins));
    } catch (err) {
      console.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [id, dispatch]);
 
  useEffect(() => {
    loadData();
  }, [loadData]);

  return { loading, error, refetch: loadData };
};


const ENDPOINTS = {
  location: { url: "list-location", titleKey: "location_name" },
  beacon: { url: "list-QrBeacon", titleKey: "beacon_name" },
  amenity: { url: "list-amenity", titleKey: "amenity_name" },
  safety: { url: "list-safety", titleKey: "safety_name" }, 
  product:  { url: "product-list",   titleKey: "product_name", extraUrl: "product-list", extraParams: "?type=2" },
  vertical: { url: "list-vTransport", titleKey: "vt_name" },
};  

const formatItems = (data, titleKey, category) => {
  const items = data || [];

  const mapped = items.map((item) => {
    const group_details = item.group_details?.length
      ? item.group_details.map((detail) => ({
          ...detail,
          fp_id:     item?.fp_id,
          enc_id:    item?.enc_id,
          positions: item?.positions,
        }))
      : item.group_details;

    return { ...item, group_details, title: item[titleKey], category };
  });

  return mapped;
};

const fetchCategory = async (id, category, config) => {
  if (!config) return null;
  
  if (category === "product") {
    const [res1, res2] = await Promise.all([
      getRequest(`${config.url}/${id}`),
      getRequest(`${config.extraUrl}/${id}${config.extraParams}`),
    ]);
    
    const data = [
      ...formatItems(res1?.data, config.titleKey, category),
      ...formatItems(res2?.data, config.titleKey, category),
    ];
    
    return { category, data };
  }
  
  const res = await getRequest(`${config.url}/${id}`);
  let formatted = formatItems(res?.data, config.titleKey, category);
  
  // if (category === "vertical") { 
  //   formatted = formatItems(DUMMY_VERTICAL, config.titleKey, category);
  //   // formatted = formatted.map((item) => ({
  //   //   ...item,
  //   //   position: item?.positions ? JSON.parse(item.positions) : "",
  //   // }));
  // }
  
  return { category, data: formatted };
};

export const fetchPinData = async (id, categories = Object.keys(ENDPOINTS)) => {
  const results = await Promise.all(
    categories.map((category) => fetchCategory(id, category, ENDPOINTS[category]))
  );
  
  return results.reduce((acc, curr) => {
    if (curr) acc[curr.category] = curr.data;
    return acc;
  }, {});
};

export const fetchFloorData = async (dispatch, currentFloor) => {   
  // if(!currentFloor) return
  
  // let getFloorData = await GetFloorData(currentFloor.enc_id)  
  
  // let verticalItem = (getFloorData?.vertical_transports || []).map((item) => ({
    //   ...item,
  //   category:"vertical_transport",
  //   title:item?.vt_name ?? ''
  // }))  
  
  // dispatch(
  //   setPinsByCategory({
  //     vertical_transport : verticalItem
  //   }
  // )); 
};